import React from 'react';
import * as util from "../other/util.js";
import { GameData } from "../share/game-data.js";
import ShipDesign from "../share/ship-design.js";
import ShipCostFormulas from "../share/formulas/ship-cost-formulas.js";
import * as Backend from "../backend.js";
import ResourceVector from "../share/resource-vector.js";
import ResourcesView from "./resources-view.js";
import ShipStatistics from "./ship-statistics-view.js";
import { Link } from "react-router-dom";

// Allows the player to configure new ship designs
export default class PlanetShipDesignView extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            ship_design: new ShipDesign(),
            ship_design_cost: new ResourceVector().init(),
            ship_design_time: 0,
            ship_build_cost: new ResourceVector().init(),
            ship_build_time: 0,
        }

        this._handleConfigChange = this._handleConfigChange.bind(this);
    }

    render() {
        let planet = this.props.planet;

        if (!planet.ship_design_project) {
            return (<div><h2>Ship Design</h2>
                <pre>Must build ship yard first.</pre>
            </div>)
        }

        if (planet.ship_design_project.active) {
            const event = planet.ship_design_project.event;
            return (<ActiveShipDesignProjectView ship_event={event} planet={planet} />)
        }

        return (
            <div>
                <h2>Ship Design</h2>
                <div style={{ display: "flex" }}>
                    <div style={{ flex: "40%" }}>
                        {this.renderInputColumn()}
                    </div>
                    <div style={{ flex: "60%" }}>
                        <ShipStatistics shipDesign={this.state.ship_design} />
                        {this.renderDesignCostColumn()}
                        {this.renderBuildCostColumn()}
                    </div>
                </div>
                <div className="action-button"
                    onClick={() => this.handleDesignRequest()}>Start Design
                </div>
            </div>
        );
    }

    renderInputColumn() {
        let ship_config = this.state.ship_design.config;
        let playerTechnologies = this.props.playerTechnologies;

        return (
            <div>
                <div className="ship-design-box">
                    <h3>Primary</h3>
                    {this.renderNameInput()}
                    <div className="ship-design-box-input-row">
                        <label>{GameData.TECHNOLOGY_BY_ID["body"].ui_name}:</label>
                        <span>{ship_config.body}</span>
                    </div>
                    <ShipRole shipConfig={ship_config} onChange={this._handleConfigChange} />
                    <ShipTechnology technologyId="storage" playerTechnologies={playerTechnologies} shipConfig={ship_config} onChange={this._handleConfigChange} />
                </div>
                <div className="ship-design-box">
                    <h3>Propulsion</h3>
                    <ShipTechnology technologyId="combustion" playerTechnologies={playerTechnologies} shipConfig={ship_config} onChange={this._handleConfigChange} />
                    {/*<ShipTechnology technologyId="ion" playerTechnologies={playerTechnologies} shipConfig={ship_config} onChange={this._handleConfigChange}/>*/}
                    {/*<ShipTechnology technologyId="spacefold" playerTechnologies={playerTechnologies} shipConfig={ship_config} onChange={this._handleConfigChange}/>*/}
                </div>
                <div className="ship-design-box">
                    <h3>Offence</h3>
                    <ShipTechnology technologyId="projectile" playerTechnologies={playerTechnologies} shipConfig={ship_config} onChange={this._handleConfigChange} />
                    {/*<ShipTechnology technologyId="beam" playerTechnologies={playerTechnologies} shipConfig={ship_config} onChange={this._handleConfigChange}/>*/}
                    {/*<ShipTechnology technologyId="wave" playerTechnologies={playerTechnologies} shipConfig={ship_config} onChange={this._handleConfigChange}/>*/}
                </div>
                <div className="ship-design-box">
                    <h3>Defence</h3>
                    <ShipTechnology technologyId="armor" playerTechnologies={playerTechnologies} shipConfig={ship_config} onChange={this._handleConfigChange} />
                    {/*<ShipTechnology technologyId="shield" playerTechnologies={playerTechnologies} shipConfig={ship_config} onChange={this._handleConfigChange}/>*/}
                </div>
                <div className="ship-design-box">
                    <h3>Auxiliary</h3>
                    <ShipTechnology technologyId="colo" playerTechnologies={playerTechnologies} shipConfig={ship_config} onChange={this._handleConfigChange} />
                    <ShipTechnology technologyId="repair" playerTechnologies={playerTechnologies} shipConfig={ship_config} onChange={this._handleConfigChange} />
                    {/*<ShipTechnology technologyId="inva" playerTechnologies={playerTechnologies} shipConfig={ship_config} onChange={this._handleConfigChange}/>*/}
                    {/*<ShipTechnology technologyId="recycle" playerTechnologies={playerTechnologies} shipConfig={ship_config} onChange={this._handleConfigChange}/>*/}
                    {/*<ShipTechnology technologyId="raid" playerTechnologies={playerTechnologies} shipConfig={ship_config} onChange={this._handleConfigChange}/>*/}
                    {/*<ShipTechnology technologyId="stealth" playerTechnologies={playerTechnologies} shipConfig={ship_config} onChange={this._handleConfigChange}/>*/}
                </div>
            </div>);
    }

    renderNameInput() {
        return (
            <div className="ship-design-name-row">
                <label>Ship Name:</label>
                <input key={"name"}
                    value={this.state.ship_design.name ? this.state.ship_design.name : ""}
                    onFocus={(event) => event.target.select()}
                    onChange={(event) => this.handleNameChange(event)} />
            </div>
        );
    }

    renderDesignCostColumn() {
        let cost = this.state.ship_design_cost;
        let time = this.state.ship_design_time;

        return (
            <div className="ship-design-box" style={{ width: "100%" }}>
                <h3>Ship Design Cost</h3>
                <ResourcesView resources={cost} display={["worker", "metal", "plastic"]} />
                <span>Time: <util.TimeSpan style={{ display: "inplace" }} timeSpan={time} /></span>
            </div>);
    }

    renderBuildCostColumn() {
        let cost = this.state.ship_build_cost;
        let time = this.state.ship_build_time;

        return (
            <div className="ship-design-box" style={{ width: "100%" }}>
                <h3>Ship Build Cost</h3>
                <ResourcesView resources={cost} display={["worker", "metal", "plastic"]} />
                <div>Time: <util.TimeSpan timeSpan={time} /></div>
            </div>);
    }

    _handleConfigChange(id, value) {
        let planet = this.props.planet;

        // Update ship config
        const ship_design = new ShipDesign(this.state.ship_design);
        ship_design.config[id] = value;
        ship_design.refreshStats();

        this.setState({
            ship_design: ship_design,
            ship_design_cost: ShipCostFormulas.getShipDesignCost(ship_design.config),
            ship_design_time: ShipCostFormulas.getShipDesignTime(ship_design.config, planet.buildings.ship_factory),
            ship_build_cost: ShipCostFormulas.getShipBuildCost(ship_design.config),
            ship_build_time: ShipCostFormulas.getShipBuildTime(ship_design.config, planet.buildings.ship_factory),
        }
        );
    }

    handleNameChange(event) {
        let new_state = util.clone(this.state);
        new_state.ship_design.name = event.target.value;
        this.setState(new_state);
    }

    handleDesignRequest() {
        let planet = this.props.planet;
        let x = planet.x;
        let y = planet.y;
        let z = planet.z;
        Backend.tryStartShipDesign(x, y, z, this.state.ship_design, (res) => {
            if (res.success) {
                this.props.onUpdatePlanet(res.planet);
            } else {
                alert(res.error);
            }
        });
    }
}

class ShipTechnology extends React.Component {
    render() {
        let technology_id = this.props.technologyId;
        let technology = GameData.TECHNOLOGY_BY_ID[technology_id];
        let player_tech = this.props.playerTechnologies[technology_id];
        let selected_level = this.props.shipConfig[technology_id];
        let available_level = player_tech != null ? player_tech : 0;
        let is_level_possible = selected_level <= available_level;

        if (!player_tech) {
            return null;
        }

        return (
            <div className="ship-design-box-input-row">
                <label>{technology.ui_name}:</label>
                <input type="number"
                    style={{ borderColor: is_level_possible ? undefined : "red" }}
                    value={selected_level}
                    onFocus={(event) => event.target.select()}
                    onChange={(event) => this.handleChange(event)} />
            </div>
        );
    }

    handleChange(event) {
        let value = event.target.value;
        if (value < 0) {
            value = 0;
        }
        this.props.onChange(this.props.technologyId, Number(value));
    }
}

class ShipRole extends React.Component {
    render() {
        const ship_config = this.props.shipConfig;

        return <div className="ship-design-box-input-row">
            <label>Role:</label>
            <select onChange={(event) => this._onSelect(event)} value={ship_config.role}>
                {GameData.SHIP_ROLES.map((role, idx) => <option key={idx} value={role.id}>{role.ui_name}</option>)}
            </select>
        </div>
    }

    _onSelect(event) {
        this.props.onChange("role", event.target.value);
    }
}

class ActiveShipDesignProjectView extends React.Component {
    render() {
        const event = this.props.ship_event;
        const planet = this.props.planet;
        return (
            <div>
                <h2>Ship Design</h2>
                <pre>Working on:</pre>
                <table className="generic-list" style={{ margin: "16px" }}>
                    <thead>
                        <tr>
                            <td>Ship Design Name</td>
                            <td>Duration</td>
                            <td>Finish Time</td>
                            <td />
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td style={{ width: "40%" }}>
                                <Link className="link-button" to={"/game/ship-design/" + event.ship_design.id}>{event.ship_design.name}</Link>
                            </td>
                            <td style={{ width: "20%", paddingRight: "12px" }}>
                                <util.Timer style={{ display: "block" }} date={event.finished}
                                    ready={<Link className="link-button" to={"/game/planet-construction" + util.getPlanetUrl(planet)}>refresh: &#x21bb;</Link>} />
                            </td>
                            <td>
                                <div>{util.RealTime.timePointToHtml(event.finished)}</div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    }
}